export default __webpack_public_path__ + "static/media/048.2ca4b6af.png";